const ListQuerys = () => import(/* webpackChunkName: "query-group" */ '@/views/query/ListQuerys')

export default [
  {
    path: 'querys',
    name: 'list-querys',
    components: {
      studyContent: ListQuerys
    },
    meta: {
      title: '数据疑问'
    }
  }
]
